import { memo, useContext, useState } from 'react';
import ContactSection from './ContactSection';
import HealthSection from './HealthSection';
import WorkIncomeSection from './WorkIncomeSection';
import Button from '../../shared/Button';
import GetDataModal from './GetDataModal';
import { bool, func, number, string } from 'prop-types';
import { Box, Cluster } from '../../shared/layouts';
import Header from '../../shared/Header';
import PersonSection from './PersonSection';
import RemoveIcon from 'imagesUwKluis/svg/close.svg';
import { useMediaQuery } from '@dnhb/node_package';
import { useTheme } from '@emotion/react';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const ProfileBlock = memo(
  ({
    firstname,
    initials,
    addition,
    lastname,
    date_of_birth,
    aow_date,
    gender,
    phone_number,
    email,
    gross_yearly_income,
    handleChange,
    pension_income,
    partner,
    child,
    is_smoker,
    onRemove,
    errors,
    showSaveBtn,
  }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { breakpoints } = useTheme();
    const isMinDesktop = useMediaQuery(
      `(min-width: ${breakpoints.ml ?? '56.25rem'})`
    );
    let { canEditProfile } = useContext(WhiteLabelContext);
    canEditProfile = child ? false : canEditProfile;
    const readOnly = !canEditProfile;
    const FormFiller = (props) => !readOnly && <Box {...props} />;
    const { ProfileIcon } = useIconLibrary();

    return (
      <>
        <GetDataModal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} />
        <Header
          title={
            partner ? (
              <Cluster hGap="l">
                <span>{t('Gegevens partner')}</span>
                {canEditProfile && (
                  <RemoveIcon
                    width="2rem"
                    height="2rem"
                    css={({ colors }) => ({
                      fill: colors?.alert || 'red',
                      cursor: 'pointer',
                      margin: '0.25rem',
                    })}
                    onClick={onRemove}
                  />
                )}
              </Cluster>
            ) : (
              child ? t('Gegevens kind') : t('Gegevens')
            )
          }
          icon={<ProfileIcon height="2rem" width="2rem" />}
          variant="page"
          button={
            showSaveBtn && isMinDesktop && canEditProfile ? (
              <Button type="submit">{t('Opslaan')}</Button>
            ) : null
          }
        />
        <PersonSection
          {...{
            handleChange,
            initials,
            firstname,
            addition,
            lastname,
            date_of_birth,
            aow_date,
            gender,
            errors,
            partner,
            readOnly,
            FormFiller,
          }}
        />

        {(canEditProfile || phone_number || email) && (
          <ContactSection
            {...{
              handleChange,
              phone_number,
              email,
              errors,
              partner,
              readOnly,
              FormFiller,
            }}
          />
        )}

        {!!(canEditProfile || gross_yearly_income || pension_income) && (
          <WorkIncomeSection
            {...{
              handleChange,
              gross_yearly_income,
              pension_income,
              errors,
              partner,
              readOnly,
              FormFiller,
            }}
          />
        )}

        {(canEditProfile) && (
          <HealthSection
            {...{
              handleChange,
              is_smoker,
              errors,
              partner,
              readOnly,
              FormFiller,
            }}
          />
        )}
      </>
    );
  }
);

ProfileBlock.propTypes = {
  firstname: string,
  initials: string,
  addition: string,
  lastname: string,
  date_of_birth: string,
  aow_date: string,
  gender: string,
  phone_number: string,
  email: string,
  gross_yearly_income: number,
  handleChange: func,
  pension_income: number,
  partner: bool,
  is_smoker: bool,
  onRemove: func,
  showSaveBtn: bool,
};

ProfileBlock.defaultProps = {
  firstname: '',
  initials: '',
  addition: '',
  lastname: '',
  date_of_birth: '',
  aow_date: '',
  gender: '',
  phone_number: '',
  email: '',
  gross_yearly_income: null,
  pension_income: null,
  partner: false,
  is_smoker: null,
  showSaveBtn: false,
};

export default ProfileBlock;
